/* Project Import will be here */
import { post, IRequest } from "./index";
import { IFavoriteProductParams, IApplyFilterParams, ISchemeProductParams } from "models/productModels";
/* Project Import will be here */

export const applyFilterApi = (data: IApplyFilterParams) => {
  const request: IRequest = { subUrl: `/Product/ApplyFilter`, data };
  return post(request);
};

export const getSchemeProductsApi = (data: ISchemeProductParams) => {
  const request: IRequest = { subUrl: `/Product/SchemeProduct`, data };
  return post(request);
};

/* Opportunity products API information */
export const getOpportunitiesApi = (data: IApplyFilterParams) => {
  const request: IRequest = { subUrl: `/Product/OpportunityProducts`, data };
  return post(request);
};

/* Favourite Products API information */
export const updateFavouriteProduct = (data: IFavoriteProductParams) => {
  const request: IRequest = { subUrl: `/Product/FavouriteProduct`, data };
  return post(request);
};

/* Relevant Products API information */
export const getRelevantProductsApi = (data: IApplyFilterParams) => {
  const request: IRequest = { subUrl: `/Product/RelevantProducts`, data };
  return post(request);
};

/* Similar Products API information */
export const getSimilarProductsApi = (data: IApplyFilterParams) => {
  const request: IRequest = { subUrl: `/Product/SimilarProduct`, data };
  return post(request);
};